import axios from "../../../axios"
import { getCurrentTenant} from '@/utils'

export default {
    fetch() {
        axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql';
        return axios.post('', {
            query: `
                query {
                    customerProducts {
                        instance_id,
                        product_id,
                        retailer_id,
                        name,
                        description,
                        url,
                        currency,
                        price,
                        is_hidden,
                        max_available,
                        availability,
                        checkmark,
                        image_hashes_for_whatsapp,
                        image_cdn_urls,
                        additional_image_cdn_urls,
                        whatsapp_product_can_appeal,
                        capability_to_review_status
                    }
                }
            `
        })
    },

    createCustomersProducts(data) {
        axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql';
        return axios.post('', {
            query: `
                mutation {
                    createNewCustomersProducts (
                        instance_id: ${data.instance_id},
                        name: "${data.name}",
                        image_cdn_urls: "${data.image}",
                        description: """${data.description}""",
                        price: "${data.price}",
                        is_hidden: ${data.hidden},
                        url: """${data.url}""",
                        retailer_id: "${data.code}",
                        currency: "BRL"
                    ) {
                        instance_id,
                        product_id,
                        retailer_id,
                        name,
                        description,
                        url,
                        currency,
                        price,
                        is_hidden,
                        max_available,
                        availability,
                        checkmark,
                        image_hashes_for_whatsapp,
                        image_cdn_urls,
                        additional_image_cdn_urls,
                        whatsapp_product_can_appeal,
                        capability_to_review_status
                    }
                }
            `
        })
    },
    syncProducts(instance_id) {
        axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql';
        return axios.post('', {
            query: `
                mutation {
                    createCustomersProducts (
                        instance_id: ${instance_id}
                    ) {
                        instance_id,
                        product_id,
                        retailer_id,
                        name,
                        description,
                        url,
                        currency,
                        price,
                        is_hidden,
                        max_available,
                        availability,
                        checkmark,
                        image_hashes_for_whatsapp,
                        image_cdn_urls,
                        additional_image_cdn_urls,
                        whatsapp_product_can_appeal,
                        capability_to_review_status
                    }
                }
            `
        })
    },
    updateStatusOrderByMsg(customer_chat_id, status) {
        axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql';
        return axios.post('', {
            query: `
                mutation {
                    updateStatusOrderByMsg (
                        customer_chat_id: ${customer_chat_id},
                        status: ${status}
                    )
                }
            `
        })
    },
    getOrderByMsg(id, instance_id) {
        axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql';
        return axios.post('', {
            query: `
                query {
                    getOrderByMsg (
                        instance_id: ${instance_id},
                        customer_chat_id: ${id}
                    ) {
                        instance_id,
                        customer_chat_id,
                        product_id,
                        price,
                        thumbnailId,
                        thumbnailUrl,
                        currency,
                        name,
                        quantity,
                        status
                    }
                }
            `
        })
    },
    createOrderByMsg(id, instance_id) {
        axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql';
        return axios.post('', {
            query: `
                mutation {
                    createOrderByMsg (
                        instance_id: ${instance_id}
                        customer_chat_id: ${id},
                    ) {
                        instance_id,
                        customer_chat_id,
                        product_id,
                        price,
                        thumbnailId,
                        thumbnailUrl,
                        currency,
                        name,
                        quantity
                    }
                }
            `
        })
    },
    deleteItem(instance_id, product_id) {
        axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql';
        return axios.post('', {
            query: `
                mutation {
                    deleteCustomersProducts (
                        instance_id: ${instance_id},
                        product_id: "${product_id}"
                    ) {
                        instance_id,
                        product_id
                    }
                }
            `
        })
    },
    editItem(product) {
        axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql';
        return axios.post('', {
            query: `
                mutation {
                    updateCustomersProducts(
                        instance_id: ${product.instance_id},
                        product_id: "${product.product_id}",
                        name: "${product.name}",
                        image_cdn_urls: "${product.image}",
                        description: """${product.description}""",
                        price: "${product.price}",
                        is_hidden: ${product.hidden},
                        url: "${product.url}",
                        retailer_id: "${product.code}",
                    )
                }
            `
        })
    },
    updateHiddenCustomersProducts(instance_id, productId, Ishidden) {
        axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql';
        return axios.post('', {
            query: `
                mutation {
                    updateHiddenCustomersProducts (
                        instance_id: ${instance_id},
                        product_id: "${productId}",
                        is_hidden: ${Ishidden}
                    ) {
                        instance_id,
                        product_id,
                        name,
                        is_hidden
                    }
                }
            `
        })
    },
    getCollections(instance_id) {
        axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql';
        return axios.post('', {
            query: `
                query {
                    getCollections (
                        instance_id: ${instance_id},
                    ) {
                        instance_id,
                        collection_id,
                        name,
                        is_hidden,
                        total_items_count,
                        products
                    }
                }
            `
        })
    },
    createCollections(instanceId, name, products) {
        axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql';
        return axios.post('', {
            query: `
                mutation {
                    createCollections (
                        instance_id: ${instanceId},
                        name: "${name}",
                        products: """${products}""",
                    ) {
                        instance_id,
                        name,
                        products
                    }
                }
            `
        })
    },
    editCollections(instanceId, id, options) {
        axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql';
        return axios.post('', {
            query: `
                mutation {
                    updateCollections (
                        instance_id: ${instanceId},
                        collection_id: "${id}",
                        products: """${options}""",
                    ) {
                        instance_id,
                        collection_id,
                        products
                    }
                }
            `
        })
    },
    deleteCollections(instanceId, collectionId, is_connected = true) {
        axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql';
        return axios.post('', {
            query: `
                mutation {
                    deleteCollections (
                        instance_id: ${instanceId},
                        collection_id: "${collectionId}",
                        is_connected: ${is_connected}
                    )
                }
            `
        })
    },
    verifyBusiness(instanceId) {
        axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql';
        return axios.post('', {
            query: `
                mutation {
                    verifyBusiness (
                        instance_id: ${instanceId},
                    ) {
                        instance_id
                    }
                }
            `
        })
    },
}
